module.exports = __webpack_public_path__ + "static/media/l_dot_7.8f76c44c.png";